import PropTypes from 'prop-types';
import React, {Component} from "react";
import {Dropdown, DropdownToggle, DropdownMenu, Row, Col} from "reactstrap";
import SimpleBar from "simplebar-react";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import {notificationDropdownRefresh} from "../../../store/layout/notificationDropdown/actions";
import UserNotificationsModal from "../../../pages/UserNotificationsModal";

class NotificationDropdown extends Component {
  constructor(props) {
    super(props)
    this.state = {
      menu: false,
      count: this.props.count,
      notifications: this.props.notifications,
      userNotificationsModal: false,
    }
    this.toggle = this.toggle.bind(this)
    this.togUserNotificationsModal = this.togUserNotificationsModal.bind(this)
  }

  componentDidMount() {
    this.props.onNotificationDropdownRefresh({history: this.props.history})
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        count: this.props.count,
        notifications: this.props.notifications,
      })
    }
  }

  toggle() {
    this.setState(prevState => ({
      menu: !prevState.menu,
    }))
  }

  togUserNotificationsModal() {
    this.setState(prevState => ({
      userNotificationsModal: !prevState.userNotificationsModal,
    }))
  }

  render() {
    return (
      <React.Fragment>
        <Dropdown isOpen={this.state.menu} toggle={this.toggle} className="dropdown d-inline-block" tag="li">
          <DropdownToggle className="btn header-item noti-icon" tag="button" id="page-header-notifications-dropdown">
            <i className="bx bx-bell bx-tada"/>
            {this.state.count > 0 && <span className="badge bg-danger rounded-pill">{this.state.count}</span>}
          </DropdownToggle>

          <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
            <div className="p-3">
              <Row className="align-items-center">
                <Col>
                  <h6 className="m-0"> {this.props.t("Notifications")} </h6>
                </Col>
                <div className="col-auto">
                  <a className="small" onClick={() => {
                    this.togUserNotificationsModal()
                  }}>
                    {" "}
                    View All
                  </a>
                </div>
              </Row>
            </div>
            <SimpleBar style={{maxHeight: "230px"}}>
              {this.state.notifications.map((notification, key) => {
                let bg = ""
                if (notification.type === 0) {
                  bg = " bg-success"
                } else if (notification.type === 1) {
                  bg = " bg-info"
                } else if (notification.type === 2) {
                  bg = " bg-warning"
                } else if (notification.type === 3) {
                  bg = " bg-danger"
                }
                return (
                  <div key={key} className="text-reset notification-item">
                    <div className="d-flex">
                      <div className="avatar-xs me-3" style={{minWidth: 32}}>
                        <span className={"avatar-title rounded-circle font-size-16" + bg}>
                          {notification.type === 0 && <i className="bx bx-check"/>}
                          {notification.type === 1 && <i className="bx bx-info-circle"/>}
                          {notification.type === 2 && <i className="bx bx-error"/>}
                          {notification.type === 3 && <i className="bx bx-error-circle"/>}
                        </span>
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="mt-0 mb-1">
                          {this.props.t(notification.title)}
                        </h6>
                        <div className="font-size-12 text-muted">
                          <p className="mb-1">
                            {this.props.t(notification.message)}
                          </p>
                          <p className="mb-0">
                            <i className="mdi mdi-clock-outline"/>{" "}{notification.created}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}
            </SimpleBar>
            <div className="p-2 border-top d-grid">
              <a className="btn btn-sm btn-link font-size-14 text-center" onClick={() => {
                this.togUserNotificationsModal()
              }}>
                <i className="mdi mdi-arrow-right-circle me-1"/>
                <span key="t-view-more">{this.props.t("View More..")}</span>
              </a>
            </div>
          </DropdownMenu>
        </Dropdown>
        {this.state.userNotificationsModal && <UserNotificationsModal togModal={this.togUserNotificationsModal} history={this.props.history}/>}
      </React.Fragment>
    )
  }
}

NotificationDropdown.propTypes = {
  t: PropTypes.any,
  onNotificationDropdownRefresh: PropTypes.func,
}

const mapStateToProps = ({NotificationDropdown}) => ({
  count: NotificationDropdown.count,
  notifications: NotificationDropdown.notifications,
});

const mapDispatchToProps = dispatch => ({
  onNotificationDropdownRefresh: data => dispatch(notificationDropdownRefresh(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(NotificationDropdown))
